/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierActivationStatus } from "./CarrierActivationStatus";
import {
  CarrierActivationStatusFromJSON,
  CarrierActivationStatusFromJSONTyped,
  CarrierActivationStatusToJSON,
  CarrierActivationStatusToJSONTyped,
} from "./CarrierActivationStatus";

/**
 *
 * @export
 * @interface CarrierWithFSCLevels
 */
export interface CarrierWithFSCLevels {
  /**
   *
   * @type {string}
   * @memberof CarrierWithFSCLevels
   */
  carrierIdentifier: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierWithFSCLevels
   */
  fscLevels: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof CarrierWithFSCLevels
   */
  usesFCAFuelSurcharge: boolean;
  /**
   *
   * @type {CarrierActivationStatus}
   * @memberof CarrierWithFSCLevels
   */
  activationStatus: CarrierActivationStatus;
}

/**
 * Check if a given object implements the CarrierWithFSCLevels interface.
 */
export function instanceOfCarrierWithFSCLevels(
  value: object,
): value is CarrierWithFSCLevels {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("fscLevels" in value) || value["fscLevels"] === undefined) return false;
  if (
    !("usesFCAFuelSurcharge" in value) ||
    value["usesFCAFuelSurcharge"] === undefined
  )
    return false;
  if (!("activationStatus" in value) || value["activationStatus"] === undefined)
    return false;
  return true;
}

export function CarrierWithFSCLevelsFromJSON(json: any): CarrierWithFSCLevels {
  return CarrierWithFSCLevelsFromJSONTyped(json, false);
}

export function CarrierWithFSCLevelsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierWithFSCLevels {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    fscLevels: json["fscLevels"],
    usesFCAFuelSurcharge: json["usesFCAFuelSurcharge"],
    activationStatus: CarrierActivationStatusFromJSON(json["activationStatus"]),
  };
}

export function CarrierWithFSCLevelsToJSON(json: any): CarrierWithFSCLevels {
  return CarrierWithFSCLevelsToJSONTyped(json, false);
}

export function CarrierWithFSCLevelsToJSONTyped(
  value?: CarrierWithFSCLevels | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    fscLevels: value["fscLevels"],
    usesFCAFuelSurcharge: value["usesFCAFuelSurcharge"],
    activationStatus: CarrierActivationStatusToJSON(value["activationStatus"]),
  };
}
